import React from 'react';
import ErrorBoundary from '../../../components/ErrorBoundary';
import SMS from '.';
import SMSScheduled from './SMSScheduled';

const SMSScheduledPage = () => (
  <SMS scrolling>
    <ErrorBoundary>
      <React.Suspense fallback={<div />}>
        <SMSScheduled />
      </React.Suspense>
    </ErrorBoundary>
  </SMS>
);

export default SMSScheduledPage;
